import AddMoreItem from './add-more-item'
import lodash from 'lodash'
export default {
  name: 'table-item',
  components: {AddMoreItem},
  props: ['items', 'group'],
  data () {
    return {

    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    destroyItem (item) {
      this.$emit('destroyItem', item)
    },
    addItem (item) {
      this.$emit('addItem', item)
    },
    addMoreItem () {
      var items = []
      this.$loading.start()
      this.$store.dispatch('GroupChecklistItem/showGroupChecklistItem', {group_checklist_item: this.group}).then(res => {
        res.chk_items.forEach(element => {
          if (lodash.findIndex(this.items, ['id', element.id]) === -1) {
            items.push(element)
          }
        })
        this.$refs.addMoreItem.show(items)
        this.$loading.complete()
      }).catch(errors => {
        this.$loading.fail()
      })
    },
    addItemSuccess (items) {
      if (this.items === undefined) {
        this.items = items
      } else {
        this.items = this.items.concat(items)
      }
      this.$refs.addMoreItem.hide()
      this.$emit('addItemSuccess', items)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/checklist/checklist-item/table-item/table-item.js